export default __webpack_public_path__ + "static/media/ellipse_history.a4189852.svg";